import React from 'react';
import { TUser } from '@modules/users';

/**
 * Renders mention placeholders (e.g. __user-id__) as @UserName
 */

const PATTERN = /__([a-fA-F0-9]{24})__/g;

export const renderMentions = (
  content: string | undefined,
  userMap: Record<string, TUser> | undefined,
  mentionClassName: string
): React.ReactNode => {
  if (!content || !userMap) return content || null;

  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = PATTERN.exec(content)) !== null) {
    if (match.index > lastIndex) {
      parts.push(content.slice(lastIndex, match.index));
    }
    const userId = match[1];
    const user = userMap[userId];
    parts.push(
      <span key={parts.length} className={mentionClassName}>
        @{user?.name || 'Unknown user'}
      </span>
    );
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < content.length) parts.push(content.slice(lastIndex));

  return parts.map((part, i) => (typeof part === 'string' ? <span key={i}>{part}</span> : part));
};
